import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Parser from "html-react-parser";
import Button from "../shared/button/Button";
import labels from "./labels";
import Saving from "../shared/loaders/Saving";
import {
  DisengageWrapper,
  Modal,
  Title,
  CloseButton,
  Inner,
  Form,
  Label,
  TextInput,
  ButtonsWrapper,
  Field,
  Error,
} from "./styles/disengage-form-styles";

const DisengageForm = (props) => {
  const {
    closeDisengageModal,
    handleDisengageOnSubmit,
    setDisengagementMessage,
    formLoading,
    errors,
  } = props;

  return (
    <DisengageWrapper>
      <Modal>
        <Title>
          Confirm Disengagement
          <CloseButton onClick={(e) => closeDisengageModal(e)}>
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
        </Title>
        <Inner>
          {formLoading && <Saving white />}
          <Form onSubmit={handleDisengageOnSubmit}>
            <Label>{Parser(labels.disengage)}</Label>
            <Field>
              <TextInput
                placeholder="Enter your message..."
                onChange={setDisengagementMessage}
              />
              {errors.disengagement_message && (
                <Error>{`Message ${errors.disengagement_message}.`}</Error>
              )}
            </Field>
            <ButtonsWrapper>
              <Button
                secondary
                buttonName="Cancel"
                onClickAction={(e) => closeDisengageModal(e)}
              />
              <Button primary buttonName="Disengage" type="submit" />
            </ButtonsWrapper>
          </Form>
        </Inner>
      </Modal>
    </DisengageWrapper>
  );
};

DisengageForm.propTypes = {
  closeDisengageModal: PropTypes.func.isRequired,
  handleDisengageOnSubmit: PropTypes.func.isRequired,
  setDisengagementMessage: PropTypes.func.isRequired,
  formLoading: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    disengagement_message: PropTypes.string,
  }),
};

DisengageForm.defaultProps = {
  errors: PropTypes.shape({}),
};

export default DisengageForm;
